import { useEmulatorRows as useSharedEmulatorRows } from "@repo/components/emulator-view";
import { useSession } from "./session";

export * from "@repo/components/emulator-view";

/** Emulators joined with their deployment status and source snapshot. */
export function useEmulatorRows() {
  return useSharedEmulatorRows(useSession());
}
